import $ from 'jquery';
import { trackToolUsage } from '../../utils/Analytics';

export default class CanvasDrawingHandler {
  constructor() {
    this.canvas = document.getElementById('canvasInAPerfectWorld');
    this.context = this.canvas.getContext('2d');
    this.curTool = 'marker';
    this.curColor = 'rgb(0, 0, 0)';
    this.curBrushSize = 'size-small';
    this.hasDrawnOnce = false;

    this.prevState = {
      tool: null,
      color: null,
      brushSize: null
    };

    this.handlePointerDown = this.handlePointerDown.bind(this);
    this.init();
    this.setupJQueryEvents();
  }

  init() {
    this.canvas.addEventListener('mousedown', this.handlePointerDown);
    this.canvas.addEventListener('touchstart', this.handlePointerDown);
  }

  handlePointerDown(e) {
    const currentState = {
      tool: this.curTool,
      color: this.curColor,
      brushSize: this.curBrushSize
    };

    const sizeMapping = {
      'size-small': 'brush_size_small',
      'size-normal': 'brush_size_medium',
      'size-large': 'brush_size_large',
      'size-huge': 'brush_size_huge'
    };

    // First draw tracking
    if (!this.hasDrawnOnce) {
      this.hasDrawnOnce = true;

      trackToolUsage('font');
      trackToolUsage('text_size');
    }

    if (this.prevState.tool !== currentState.tool) {
      console.log('[Canvas] Tool changed to:', currentState.tool);
      trackToolUsage(currentState.tool);
      this.prevState.tool = currentState.tool;
    }


    if (this.prevState.brushSize !== currentState.brushSize) {
      const brushSizeEvent = sizeMapping[currentState.brushSize];
      console.log('[Canvas] Tool changed to:', brushSizeEvent);
      trackToolUsage(brushSizeEvent);
      this.prevState.brushSize = currentState.brushSize;
    }

    if (this.prevState.color !== currentState.color) {
      console.log('[Canvas] Tool changed to:', currentState.color);
      trackToolUsage('color_picker');
      this.prevState.color = currentState.color;
    }
  }

  setupJQueryEvents() {
    $('.tool-img').on('click', (e) => {
      this.curTool = e.currentTarget.id;
      console.log('[Canvas] Tool changed via jQuery to:', this.curTool);
    });

    $('.size-brush').on('click', (e) => {
      this.curBrushSize = e.currentTarget.id;
      console.log('[Canvas] Brush Size changed via jQuery to:', this.curBrushSize);
    });

    $('.popover').on('click', (e) => {
      this.curColor = $('.color-picker-btn').css('background-color');
      console.log('[Canvas] curColor changed via jQuery to:', this.curColor);
    });
  }

  destroy() {
    this.canvas.removeEventListener('mousedown', this.handlePointerDown);
    this.canvas.removeEventListener('touchstart', this.handlePointerDown);
  }
}
